import { ELEVATIONS } from '../elevation'

const BaseTheme = {
  breakpoints: {
    xs: 480,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    xxl: 1536,
    fullhd: 1920,
    ultrahd: 3840,
  },
  remBase: 16,
  spaceBase: 16,
  elevations: ELEVATIONS,
  borderRadius: 4,
  transitionDuration: 200,
}

export default BaseTheme
